import React, { useEffect, useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectCards, EffectCoverflow, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import Aos from "aos";
import "aos/dist/aos.css";

function MyApp() {
  useEffect(() => {
    window.addEventListener("load", () => {
      Aos.init({
        duration: 1000,
      });
      Aos.refresh();
    });
  }, []);
  const state = {};
  let elems;
  useEffect(() => {
    const carouselList = document.querySelector(".carousel__list");
    const carouselItems = document.querySelectorAll(".carousel__item");
    elems = Array.from(carouselItems);

    carouselList.addEventListener("click", function (event) {
      var newActive = event.target;
      var isItem = newActive.closest(".carousel__item");

      if (!isItem || newActive.classList.contains("carousel__item_active")) {
        return;
      }

      const newActivePos = newActive.dataset.pos;

      const current = elems.find((elem) => elem.dataset.pos == 0);
      const prev = elems.find((elem) => elem.dataset.pos == -1);
      const next = elems.find((elem) => elem.dataset.pos == 1);
      const first = elems.find((elem) => elem.dataset.pos == -2);
      const last = elems.find((elem) => elem.dataset.pos == 2);

      current.classList.remove("carousel__item_active");

      [current, prev, next, first, last].forEach((item) => {
        var itemPos = item.dataset.pos;

        item.dataset.pos = getPos(itemPos, newActivePos);
      });
    });
  }, []);

  const getPos = function (current, active) {
    const diff = current - active;

    if (Math.abs(current - active) > 2) {
      return -current;
    }

    return diff;
  };
  return (
    <div className="myapp">
      <div className="header-container">
        <div className="header">
          <div className="home-bar">
            <i class="fa-solid fa-minus"></i>
            <a href="/">Home</a>
          </div>
          <a href="#owner-container">About Us</a>
          <a href="#image-container">Portfolio</a>
          <a href="#conference-container">Pages</a>
          <a href="#contact-container">Contact</a>
          <a href="#">
            <i class="fa-solid fa-bars-staggered"></i>
          </a>
        </div>
      </div>
      <div className="main-page">
        <div className="content-wrapper">
          <h2>
            Take it t
            <span className="to-star">
              <i class="fa-solid fa-certificate"></i>
            </span>
          </h2>
          <h2 className="second-line">
            the creative
            {/* <span> */}
            <img src="/images/rectangle_1182.png" alt="" />
            {/* </span> */}
            level
          </h2>
          <div className="intro-text">
            <p>
              <span>Specialized </span>
              <span>in </span>
              <span className="tooltip-text">user interface design. </span>
              <span>We </span>
              <span>consider </span>
              <span>to </span>
              <span>be </span>
              <span>an </span>
              <span>integral </span>
              <span>part </span>
              <span>of </span>
              <span>the </span>
              <span>best </span>
              <span>user </span>
              <span>experience. </span>
            </p>
          </div>
          <button>
            Say Hello
            <div>
              <i class="fa-solid fa-certificate"></i>
              <i class="fa-solid fa-arrow-right"></i>
            </div>
          </button>
        </div>
      </div>
      <div className="image-container w-100" id="image-container">
        <Swiper
          effect={"coverflow"}
          grabCursor={true}
          // centeredSlides={true-}
          slidesPerView={"auto"}
          coverflowEffect={{
            rotate: 50,
            stretch: 0,
            depth: 100,
            modifier: 1,
            slideShadows: true,
          }}
          pagination={true}
          modules={[EffectCoverflow, Pagination]}
        >
          <SwiperSlide>
            <img src="/images/image1.jpeg" alt="Images" />
          </SwiperSlide>
          <SwiperSlide>
            <img src="/images/image3.jpeg" alt="Images" />
          </SwiperSlide>
          <SwiperSlide>
            <img src="/images/image2.jpeg" alt="Images" />
          </SwiperSlide>
          <SwiperSlide>
            <img src="/images/image4.jpeg" alt="Images" />
          </SwiperSlide>
          <SwiperSlide>
            <img src="/images/image6.jpeg" alt="Images" />
          </SwiperSlide>
          <SwiperSlide>
            <img src="/images/image9.jpeg" alt="Images" />
          </SwiperSlide>
          <SwiperSlide>
            <img src="/images/image7.jpeg" alt="Images" />
          </SwiperSlide>
          <SwiperSlide>
            <img src="/images/image10.jpeg" alt="Images" />
          </SwiperSlide>
        </Swiper>
      </div>
      <div className="row m-0 cto-container">
        <div className="col-md-5 cto-text">
          <h3>You're a CTO or a VP of Engineering and you have a problem</h3>
          <div className="blink"></div>
          <ul>
            <li>Development isn't moving fast enough</li>
            <li>You don't have the right developers</li>
            <li>You need additional engineering capacity</li>

            <li>
              Recruting, hiring, and onboarding developers takes too much time
              and bandwidth
            </li>
            <li>You've lost key developer through attrition</li>
          </ul>
        </div>
        <div className="col-md-7 cto-image">
          <img src="/images/image_279.png" alt="CtoImage" />
        </div>
      </div>
      <div className="design-guide">
        <img src="/images/page_frame_46545.svg" alt="design-guide-img" />
        <div className="design-text">
          <h3>ULTIMATE GUIDE TO DESIGNING A HIGH-CONERTING LANDING PAGE</h3>
          <p>Learn how to designa conversation -</p>
          <p>effective landing page</p>
        </div>
      </div>
      <div className="dribble-conatiner">
        <img src="/images/mask_group.png" alt="MaskImg" />
        <div className="content-wrapper">
          <div data-aos="fade-up" className="dribble-title">
            <h2>Jesse Rayman</h2>
          </div>
          <div data-aos="fade-down" className="dribble-text">
            <h6>iT'S TALK AVAILABLE FOR WORK . LR</h6>
            <p>
              Hi, I'm Jesse Rayman. UIUX Designer based in California. I
              Specialize in creating stunning and intutive design that provide
              seamless use experiences.
            </p>
            <div>
              <span>INSTAGRAM</span>
              <span>BEHANCE</span>
              <span>DRIBBLE</span>
            </div>
          </div>
        </div>
      </div>
      <div className="row m-0 conference-container" id="conference-container">
        <div className="col-md-6 conference">
          <div className="conference-text">
            <div className="cultural-center">
              <h6>Zli cultural center</h6>
              <span>October 10-12 </span>
            </div>
            <h1>
              <span>DESIGN</span> <span>CONFERENCE</span>
            </h1>
            <div className="intro-text">
              <p>major design event and architecture for professionals.</p>
            </div>
            <button>PARTICIPATE</button>
          </div>
        </div>
        <div className="col-md-6 conference-image">
          <img src="/images/rectangle_1190.png" alt="ConferenceImage" />
        </div>
      </div>
      <div className="team-container">
        <div className="team">
          <div className="row m-0 team-image">
            <div className="col-md-3">
              <img
                src="/images/rectangle_1197.png"
                className="img1"
                alt="TeamImage1"
              />
            </div>
            <div className="col-md-3">
              <img
                src="/images/rectangle_1196.png"
                className="img2"
                alt="TeamImage1"
              />
            </div>
            <div className="col-md-3">
              <img
                src="/images/rectangle_1198.png"
                className="img3"
                alt="TeamImage1"
              />
            </div>
            <div className="col-md-3">
              <img
                src="/images/rectangle_1199.png"
                className="img4"
                alt="TeamImage1"
              />
            </div>
          </div>
          <h1>Team</h1>
        </div>
        <div className="btn">
          <button>
            Meet our creative professionals
            <div>
              <i class="fa-solid fa-certificate"></i>
              <i class="fa-solid fa-arrow-right"></i>
            </div>
          </button>
        </div>
      </div>
      <div className="book-container">
        <div className="row m-0 book">
          <div className="col-md-6 front-image">
            <img src="/images/group_297.png" alt="FrontImage" />
            <div className="book-text">
              <span>01</span>
              <h2 class="waviy">WELNESS GARDEN</h2>
              <div>
                <button>GAIN ENDURANCE</button>
                <button>GAIN MUSCLE</button>
                <button>LOSE FAT</button>
                <button>YOUR BODY</button>
                <button>YOUR MIND</button>
                <button>EMOTIONL INTELLIGENCE</button>
              </div>
            </div>
          </div>
          <div className="col-md-6 side-image">
            <img src="/images/books_4685465.svg" alt="SideImage" />
          </div>
        </div>
      </div>
      <div className="owner-container" id="owner-container">
        <div className="row m-0">
          <div className="col-md-6 px-0 img-wrapper">
            <div className="img-container">
              <img src="/images/rectangle_1202.png" alt="OwnerImage" />
              <div className="skeletons"></div>
              <div className="skeletons"></div>
            </div>
          </div>
          <div className="col-md-6 px-0 text-wrapper">
            <h2>I'M JESSICA MOUND</h2>
            <div className="content">
              <p>
                She stared out the window at the snowy field. She'd been stuck
                in the house for close to a month and her only view of the
                outside world was through the window
              </p>
              <p>
                There wasn't much to see. It was mostly just the field with an
                occasional bird or small animal who ventured into the field
              </p>
              <p>
                As she continued to stare out the window, she wondered how much
                longer she'd be shackled to the steel bar inside the house.
              </p>
              <button>
                Get to know me{" "}
                <div>
                  <i class="fa-solid fa-certificate"></i>
                  <i class="fa-solid fa-arrow-right"></i>
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="cards-container">
        <div class="carousel">
          <ul class="carousel__list">
            <li class="carousel__item" data-pos="-2">
              <h6>We’re a team of passionate creatives with 10+ years</h6>
            </li>
            <li class="carousel__item" data-pos="-1">
              <h6>experience in creating and re-creating digital solutions.</h6>
            </li>
            <li class="carousel__item" data-pos="0">
              <h6>Obsession for details is the key of every daily task</h6>
            </li>
            <li class="carousel__item" data-pos="1">
              <h6>because nothing can be left to chance when it comes</h6>
            </li>
            <li class="carousel__item" data-pos="2">
              <h6>to take your brand and company.</h6>
            </li>
          </ul>
        </div>
      </div>
      <div className="contact-container" id="contact-container">
        <h1 className="">GET</h1>
        <h1 className=""> IN TOUCH</h1>
      </div>
      <div className="footer-container">
        <div className="text">
          <div className="talk-us">
            <p>Have a great idea you wanna like to work on?</p>
            <h1 className="animate-charcter">LET'S TALK</h1>
          </div>
          <div className="connect-us">
            <div className="social-wrapper">
              <div>
                <i class="fa-brands fa-facebook-f"></i>
                <span>Facebook</span>
              </div>
              <div>
                <i class="fa-brands fa-instagram"></i>
                <span>Instagram</span>
              </div>
              <div>
                <i class="fa-brands fa-twitter"></i>
                <span>Twitter</span>
              </div>
            </div>
            <p>info@officina.com</p>
          </div>
          <div className="box2"></div>
          <div className="about-us">
            <hr />
            <div>
              <span>about</span>
              <span>work</span>
              <span>blog</span>
              <span>content</span>
            </div>
          </div>
          <div className="box3"></div>
        </div>
        <div className="box1"></div>
      </div>
    </div>
  );
}
export default MyApp;
